module.exports = __webpack_public_path__ + "houses_team.3a22c6984476a78ecf21.svg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/images/houses_team.svg
// module id = ../../../../../src/assets/images/houses_team.svg
// module chunks = styles